// FILECONTENT_START src/common/modules/doc-title/index.ts
import useDocTitle from "./useDocTitle";
export default useDocTitle;

// FILECONTENT_END src/common/modules/doc-title/index.ts